export enum PermissionType {
  "GI-GSLP_gslp.mfa" = 1,
  "GI-GSLP_gslp.createUser" = 2,
  "GI-GSLP_gslp.updateUser" = 3,
  "GI-GSLP_gslp.updateUserProfile" = 4,
  "GI-GSLP_gslp.changePassword" = 5,
  "GI-GSLP_gslp.getUser" = 6,
  "GI-GSLP_gslp.listUser" = 7,
  "GI-GSLP_gslp.lisUserCsvExport" = 8,
  "GI-GSLP_gslp.activateUser" = 9,
  "GI-GSLP_gslp.deactivateUser" = 10,
  "GI-GSLP_gslp.deregisterUser" = 11,
  "GI-GSLP_gslp.createClient" = 12,
  "GI-GSLP_gslp.updateClient" = 13,
  "GI-GSLP_gslp.getClient" = 14,
  "GI-GSLP_gslp.listClient" = 15,
  "GI-GSLP_gslp.activateClient" = 16,
  "GI-GSLP_gslp.deactivateClient" = 17,
  "GI-GSLP_gslp.deregisterClient" = 18,
  "GI-GSLP_gslp.listRole" = 19,
  "GI-GSLP_gslp.createUserForOtherOrgs" = 20,
  "GI-GSLP_gslp.createUserForAllOrgs" = 21,
  "GI-GSLP_gslp.createUserWithDiffRoles" = 22,
  "GI-GSLP_gslp.changeOtherUsersPasswords" = 23,

  "GI-GSEL_gsel.createEo" = 1000,
  "GI-GSEL_gsel.createFacility" = 1001,
  "GI-GSEL_gsel.createMachine" = 1002,
  "GI-GSEL_gsel.updateEo" = 1003,
  "GI-GSEL_gsel.updateFacility" = 1004,
  "GI-GSEL_gsel.updateMachine" = 1005,
  "GI-GSEL_gsel.getEo" = 1006,
  "GI-GSEL_gsel.getFacility" = 1007,
  "GI-GSEL_gsel.getMachine" = 1008,
  "GI-GSEL_gsel.listEo" = 1009,
  "GI-GSEL_gsel.listFacility" = 1010,
  "GI-GSEL_gsel.listMachine" = 1011,
  "GI-GSEL_gsel.activateEo" = 1012,
  "GI-GSEL_gsel.activateFacility" = 1013,
  "GI-GSEL_gsel.activateMachine" = 1014,
  "GI-GSEL_gsel.deactivateEo" = 1015,
  "GI-GSEL_gsel.deactivateFacility" = 1016,
  "GI-GSEL_gsel.deactivateMachine" = 1017,
  "GI-GSEL_gsel.approveEoRequest" = 1018,
  "GI-GSEL_gsel.approveFacilityRequest" = 1019,
  "GI-GSEL_gsel.approveMachineRequest" = 1020,
  "GI-GSEL_gsel.rejectEoRequest" = 1021,
  "GI-GSEL_gsel.rejectFacilityRequest" = 1022,
  "GI-GSEL_gsel.rejectMachineRequest" = 1023,
  "GI-GSEL_gsel.deregisterEo" = 1024,
  "GI-GSEL_gsel.deregisterFacility" = 1025,
  "GI-GSEL_gsel.deregisterMachine" = 1026,
  "GI-GSEL_gsel.verifyEo" = 1027,
  "GI-GSEL_gsel.verifyFacility" = 1028,
  "GI-GSEL_gsel.verifyMachine" = 1029,
  "GI-GSEL_gsel.updateOrganization" = 1030,
  "GI-GSEL_gsel.approveOrganization" = 1031,
  "GI-GSEL_gsel.rejectOrganization" = 1032,
  "GI-GSEL_gsel.getOrganization" = 1033,
  "GI-GSEL_gsel.listOrganization" = 1034,
  "GI-GSEL_gsel.activateOrganization" = 1035,
  "GI-GSEL_gsel.deactivateOrganization" = 1036,
  "GI-GSEL_gsel.getDashboard" = 1037,

  "GI-GSDM_gsdm.viewProductCodes" = 3000,
  "GI-GSDM_gsdm.requestUpUI" = 3001,
  "GI-GSDM_gsdm.reorderRequestUpUI" = 3002,
  "GI-GSDM_gsdm.getUpUI" = 3003,
  "GI-GSDM_gsdm.listUpUI" = 3004,
  "GI-GSDM_gsdm.verifyUpUI" = 3005,
  "GI-GSDM_gsdm.cancelUpUI" = 3006,
  "GI-GSDM_gsdm.requestAUI" = 3007,
  "GI-GSDM_gsdm.reorderRequestAUI" = 3008,
  "GI-GSDM_gsdm.getAUI" = 3009,
  "GI-GSDM_gsdm.listAUI" = 3010,
  "GI-GSDM_gsdm.verifyAUI" = 3011,
  "GI-GSDM_gsdm.cancelAUI" = 3012,
  "GI-GSDM_gsdm.downloadOrderCodes" = 3013,
  "GI-GSDM_gsdm.downloadProductCodes" = 3014,
  "GI-GSDM_gsdm.getDashboard" = 3015,

  "GI-GSCR_gscr.uiSearchLookup" = 4000,
  "GI-GSCR_gscr.multipleUILookup" = 4001,
  "GI-GSCR_gscr.uiQueryBuilder" = 4002,
  "GI-GSCR_gscr.exportCsvUISearch" = 4003,
  "GI-GSCR_gscr.uiDetail" = 4004,
  "GI-GSCR_gscr.map" = 4005,
  //"GI-GSCR_gscr.exportCsvUIAggregate" = 4006,
  "GI-GSCR_gscr.eventSearchLookup" = 4007,
  //"GI-GSCR_gscr.multipleEventLookup" = 4008,
  "GI-GSCR_gscr.eventQueryBuilder" = 4009,
  //"GI-GSCR_gscr.eventDetail" = 4010,
  "GI-GSCR_gscr.exportCsvEventSearch" = 4011,
  "GI-GSCR_gscr.alertSubscription" = 4012,
  "GI-GSCR_gscr.alertGovDashboard" = 4013,
  "GI-GSCR_gscr.getEo" = 4014,
  "GI-GSCR_gscr.getFacility" = 4015,
  "GI-GSCR_gscr.getMachine" = 4016,

  "GI-GSBI_gsbi.accessToGsbi" = 5000

}
